'use client';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { type GlobalNavData } from '../../../services/globalNavItems/types';
import { HamburgerToggle } from './HamburgerToggle';
import { useMobileNavBodyScrollLock } from './hooks';

const MobileNavMenu = dynamic(
  () => import('./MobileNavMenu').then(module => ({ default: module.MobileNavMenu })),
  { ssr: false },
);

type MobileNavProps = {
  navData: GlobalNavData;
};

export function MobileNav({ navData }: MobileNavProps) {
  useMobileNavBodyScrollLock();

  return (
    <>
      <HamburgerToggle />
      <Suspense fallback={null}>
        <MobileNavMenu navItems={navData.l1Menu} />
      </Suspense>
    </>
  );
}
